const payoutAccountHolder = [
  { label: 'PRIMARY', value: 'PRIMARY' },
  { label: 'SECONDARY', value: 'SECONDARY' },
  { label: 'BOTH', value: 'BOTH' }
]

export default payoutAccountHolder
